import types from '../constants/types'

export const authorityMutation = {
  [types.LOGIN_REQUEST] (state) {
    state.isLogining = true
    state.msg = '正在登录系统'
  },
  [types.LOGIN_SUCCESS] (state, action) {
    state.isLogining = false
    state.logged = true
    state.userInfo = action.data.info
    state.loginFailure = false
    state.loginSuccess = true
  },
  [types.LOGIN_FAILURE] (state, action) {
    state.isLogining = false
    state.msg = action.data.info || action.data.msg
    state.logged = false
    state.loginFailure = true
    state.loginSuccess = false
  },
  [types.LOGOUT_REQUEST] (state, action) {
    state.isLogouting = false
    state.msg = '正在退出系统'
  },
  [types.LOGOUT_SUCCESS] (state, action) {
    state.isLogouting = false
    state.logged = false
    state.userInfo = {}
    state.logoutSuccess = true
    state.logoutFailure = false
  },
  [types.LOGOUT_FAILURE] (state, action) {
    state.isLogouting = false
    state.logoutSuccess = false
    state.logoutFailure = true
  },
  [types.REGLOGIN_REQUEST] (state, action) {
    state.isreg = true
   
  },
  [types.REGLOGIN_FAILURE] (state, action) {
    state.isreg = false
    
  },
  [types.REGLOGIN_SUCCESS] (state, action) {
    state.isreg = false
    
  },
  [types.FORGET_REQUEST] (state, action) {
    state.isforget = true
   
  },
  [types.FORGET_FAILURE] (state, action) {
    state.isforget = false
    
  },
  [types.FORGET_SUCCESS] (state, action) {
    state.isforget = false
    
  },
}
